import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Loading from '../_components/Loading';
import { NoData } from '../_components/NoData';
import { examService } from '../_services/exam.service';
import { MockTestItemForSeries } from './MockTestItemForSeries';

export const SeriesSingleView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [mockTestData, setMockTestData] = useState([]);

  const location = useLocation();

  const { seriesData, isSubscribed } = location.state;

  useEffect(() => {
    getMockTests();
  }, []);
  const getMockTests = () => {
    setIsLoading(true);
    setMockTestData([]);
    examService.mocktestList({ isactive: 1, series_id: seriesData?._id }).then(
      (res) => {
        setIsLoading(false);

        if (res?.data?.rows?.length) {
          setMockTestData(res.data.rows);
        } else {
          setMockTestData([]);
        }
      },
      (err) => {
        console.log(err, 'this is errordata');
        setIsLoading(false);
      },
    );
  };
  return (
    <div className='container'>
      <div className='d-flex align-items-center mb-3  headcontainer'>
        <div className='home_head '>{seriesData?.series_name} </div>
      </div>
      {!isLoading && (
        <div className='d-flex align-items-center gap-1 justify-content-between'>
          <div className=''>
            <div className='d-flex flex-wrap gap-4 courselist'>
              {mockTestData?.map((test, index) => {
                return (
                  <MockTestItemForSeries mockTest={test} key={index} isSubscribed={isSubscribed} />
                );
              })}
            </div>
          </div>
        </div>
      )}
      {isLoading && !mockTestData?.length && <Loading />}
      {!isLoading && !mockTestData?.length && <NoData text='No Test Found' />}
    </div>
  );
};
